import { TrackingAction, TrackingContext } from 'src/boot/plausible'
import { AbstractEntity } from 'src/entities/AbstractEntity'
import { RouteLocationRaw } from 'vue-router'
import { ROUTE_NAME_VIEW } from 'src/router/routes'
import { Feature } from 'src/services/PermissionService'
import { useInventoryStore } from 'stores/inventory-store'

export class KeyEventEntity extends AbstractEntity {
  protected readonly defaultIcon: string = 'spi-calendar-day'
  protected readonly requiredFeatures : Feature[] = ['displayLists']

  public getNameFromInventory (): string {
    return useInventoryStore().getKeyEventById(this.id)?.name || ''
  }

  public getIcon (): string {
    return useInventoryStore().getKeyEventIconById(this.id) || this.defaultIcon
  }

  public getSubType (): string {
    return ''
  }

  public getTrackingAction (): TrackingAction {
    return TrackingAction.OPEN_KEY_EVENT
  }

  public getTrackingContext (): TrackingContext {
    return { keyEventName: this.getName(), keyEventId: this.id }
  }

  public getRouteOptions (): RouteLocationRaw {
    return { name: ROUTE_NAME_VIEW, query: { keyEvent: this.id } }
  }
}
